//SET THE OPTIONS FOR THIS MAP FOR THE THIS PAGE BELOW:
// set default map properties
var defaultLatlng = '';

// zoom level of the map
var defaultZoom = '13';

// variable for map
var map;
// variable for marker info window
var infowindow;

// List with all markers.
var markerList = {};

//Master Marker List Obj
var allMarkers = {};

//ajax processing function to load markers
var operation_to_load_markers = 'loadMarkers';

var myOptions;

var string_template = 1; //by default use string template 1 for the map pop up.

//define style for map and pass into the load map function.. build using tool @ http://gmaps-samples-v3.googlecode.com/svn/trunk/styledmaps/wizard/index.html
//THIS IS THE DEFAULT MAP STYLE TO USE.
//IF YOU NEED A SPECIALIZED MAP REDEFINE THIS ARRAY IN THE PAGE YOU ARE WORKING ON.
//DO NOT OVERWRITE THE DEFAULT, ONLY REDEFINE IN YOUR PAGE.

var styles;

function initializeMap(lat, long, zoom)
{
    //set the variables which are passed on document ready
    defaultLatlng = new google.maps.LatLng(lat, long); //set longitude and latitude
    defaultZoom = zoom;

    // set error handler for jQuery AJAX requests
    /*
     $.ajaxSetup({"error":function(XMLHttpRequest,textStatus, errorThrown) {
     alert(textStatus);
     alert(errorThrown);
     alert(XMLHttpRequest.responseText);
     }});
     */

    // option for google map object
    myOptions = {
        zoom: zoom,
        center: defaultLatlng,
        mapTypeId: google.maps.MapTypeId.SATELLITE,
        mapTypeControl : false,
        scrollwheel: false,
        disableDoubleClickZoom : false,
        backgroundColor : '#000000',
        styles : styles,
        panControl: false,
        zoomControlOptions: {
            position: google.maps.ControlPosition.LEFT_CENTER
        },

    }

    loadMap(); //load map regularly.
}





function smoothZoom (map, level, cnt, mode) {
    //alert('Count: ' + cnt + 'and Max: ' + level);

    // If mode is zoom in
    if(mode == true) {

        if (cnt >= level) {
            return;
        }
        else {
            var z = google.maps.event.addListener(map, 'zoom_changed', function(event){
                google.maps.event.removeListener(z);
                smoothZoom(map, level, cnt + 1, true);
            });
            setTimeout(function(){map.setZoom(cnt)}, 80);
        }
    } else {
        if (cnt <= level) {
            return;
        }
        else {
            var z = google.maps.event.addListener(map, 'zoom_changed', function(event) {
                google.maps.event.removeListener(z);
                smoothZoom(map, level, cnt - 1, false);
            });
            setTimeout(function(){map.setZoom(cnt)}, 80);
        }
    }
}


/**
 * Load Map
 */
function loadMap()
{
    // create new map make sure a DIV with id myMap exist on page
    map = new google.maps.Map(document.getElementById("myMap"), myOptions); //generate map into div id myMap

    // create new info window for marker detail pop-up
    var infoBoxOptions = {
        content: '',
        disableAutoPan: false,
        pixelOffset: new google.maps.Size(-110, 6),
        zIndex: null,
        closeBoxMargin: "-8px -8px -11px 2px",
        closeBoxURL: site_url+"assets/images/close.png",
        infoBoxClearance: new google.maps.Size(6, 6),
        isHidden: false,
        pane: "floatPane",
        alignBottom : false,
        enableEventPropagation: false
    };

    infowindow = new InfoBox(infoBoxOptions); //create the infoBox. will begin as hidden but then we show and hide this.

    google.maps.event.addDomListener(window, 'resize', function() {
        map.setCenter(defaultLatlng);
    });

}

function viewAllMarkers()
{
    clearOverlays(); //clear any overlays to prevent double pinning

    loadMarker(hotel_marker); //load main hotel marker

    //loop thru all markers obj and programmatically click each checkbox
    $('.pin-cat').each(function(){
        if( !$(this).is(':checked') )
        {
            this.click();
        }
    });
}

function clickCat(cat, is_checked)
{
    $.each(allMarkers[cat], function(){
        if(is_checked){loadMarker(this);} //category was checked load the pins in it
        else{unloadMarker(this);} //unload the marker
    });
}


/**
 * Load marker to map
 */
function loadMarker(markerData){ //writes the marker to the map. pass a javascript object with the markers longitude latitude id and name so that the code can keep track of all the markers.

    var icon = markerData['icon'];

    var myLatlng = new google.maps.LatLng(markerData['lat'],markerData['long']);

    if(markerData['icon']=='' || !markerData.hasOwnProperty('icon')) { var icon = 'markers.png'; } //fall back on default marker

    // create new marker
    var marker = new google.maps.Marker({
        id: markerData['id'],
        map: map,
        title: markerData['name'] ,
        icon : icon,
        position: myLatlng
    });



    var icon1 = icon;


    if (marker.id == '0'){
        var icon2 = site_url+"assets/images/markers-over.png";
    }
    else{
        var icon2 = site_url+"assets/images/markers-over.png";

    }

    google.maps.event.addListener(marker, 'mouseover', function() {
        marker.setIcon(icon2);
    });
    google.maps.event.addListener(marker, 'mouseout', function() {
        marker.setIcon(icon1);
    });


    // add marker to list used later to get content and additional marker information
    markerList[marker.id] = marker;

    // add event listener when marker is clicked
    google.maps.event.addListener(marker, 'click', function() {
        // show marker when clicked
        marker.setIcon(icon2);
        google.maps.event.addListener(marker, 'mouseover', function() {
            marker.setIcon(icon2);
        });
        google.maps.event.addListener(marker, 'mouseout', function() {
            marker.setIcon(icon2);
        });

        showMarker(marker.id, markerData.name, markerData.thumb, markerData.description, markerData.url);

        map.panTo(marker.getPosition());




        //smoothZoom(map, 20, map.getZoom(), true);

        /*     if (marker.getAnimation() != null) {
         marker.setAnimation(null);
         } else {
         marker.setAnimation(google.maps.Animation.BOUNCE);
         }

         setTimeout(toggleBounce, 1500);*/

    });

    // add event when marker window is closed to reset map location. when marker is closed do this action.
    google.maps.event.addListener(infowindow,'closeclick', function() {
        //  map.setCenter(defaultLatlng); //set center back to the default when the map initialized.
        //  map.setZoom(defaultZoom); // set zoom back to default when map was initialized.
        marker.setIcon(icon1);

        google.maps.event.addListener(marker, 'mouseover', function() {
            marker.setIcon(icon2);
        });
        google.maps.event.addListener(marker, 'mouseout', function() {
            marker.setIcon(icon1);
        });


    });
}






/**
 * Load marker to map
 */
function loadMarkerwithBox(markerData){ //writes the marker to the map. pass a javascript object with the markers longitude latitude id and name so that the code can keep track of all the markers.




    var icon = markerData['icon'];

    var myLatlng = new google.maps.LatLng(markerData['lat'],markerData['long']);

    if(markerData['icon']=='' || !markerData.hasOwnProperty('icon')) { var icon = 'markers.png'; } //fall back on default marker

    // create new marker
    var marker = new google.maps.Marker({
        id: markerData['id'],
        map: map,
        title: markerData['name'] ,
        icon :  SITE_FILES+"images/markers-over.png",
        position: myLatlng
    });



    // add marker to list used later to get content and additional marker information
    markerList[marker.id] = marker;

    // add event listener when marker is clicked

    // show marker when clicked

    showMarker(marker.id, markerData.name, markerData.thumb, markerData.description, markerData.url);

    map.panTo(marker.getPosition());


    //smoothZoom(map, 20, map.getZoom(), true);

    /*     if (marker.getAnimation() != null) {
     marker.setAnimation(null);
     } else {
     marker.setAnimation(google.maps.Animation.BOUNCE);
     }

     setTimeout(toggleBounce, 1500);*/



    // add event when marker window is closed to reset map location. when marker is closed do this action.
    google.maps.event.addListener(infowindow,'closeclick', function() {
        //map.setCenter(defaultLatlng); //set center back to the default when the map initialized.
        //  map.setZoom(defaultZoom); // set zoom back to default when map was initialized.
        icona = SITE_FILES+"images/markers.png";
        iconb = SITE_FILES+"images/markers-over.png";

        marker.setIcon(icona);
        google.maps.event.addListener(marker, 'mouseover', function() {
            marker.setIcon(iconb);
        });
        google.maps.event.addListener(marker, 'mouseout', function() {
            marker.setIcon(icona);
        });

    });
}


/**
 * Show marker info window. when marker is clicked, this function is called.
 */
function showMarker(markerId, name, thumb, description, url){

    // get marker information from marker list
    var marker = markerList[markerId];

    // check if marker was found
    if( marker ){
        //generate the html that will go in the popup. generate the popup content using these string templates. customize these to your needs. can have as many string templates as needed.
        var html_string =     '<div class="map_popup">'+
            '<img src="'+thumb+'">'+
            '<div class="desc">'+
            '<h2>'+name+'</h2>'+
            '<p>'+description+'</p>'+
            '</div>'+
            '</div>';
        infowindow.setContent(html_string); //write the html to the info window
        infowindow.open(map,marker); //show the info window



    }else{
        alert('Error marker not found: ' + markerId);
    }
}


function clearOverlays() //clear all overlays.(will erase any popups or pins from the map)
{
    if (markerList) //if markerList has markers loop thru all markers and set to null on map, then delete from the markerList.
    {
        for (i in markerList) {
            markerList[i].setMap(null);

            delete markerList[i];
        }
    }

    //check if there is an info window open then close it
    if($('.infoBox').length>0)
    {
        infowindow.close(); //close the info window if there is one open.
    }

    //clear overlays should set checkboxes to false because nothing is selected
    $('.pin-cat').each(function(){ $(this).prop('checked',false); });

}

function unloadMarker(markerData)
{
    if (markerList[markerData['id']]) //if markerList has the marker then delete it
    {
        markerList[markerData['id']].setMap(null);
        delete markerList[markerData['id']];
    }

    //check if there is an info window open then close it
    if($('.infoBox').length>0)
    {
        infowindow.close(); //close the info window if there is one open.
    }
}

function myclick(obj, i) {
    google.maps.event.trigger(gmarkers[i], "click");
    map.panTo(gmarkers[i].getPosition());
    map.setZoom(14);
    $('a.place').parent().removeClass('active');
    $(obj).parent().addClass('active');
}